
<template>
    <div class="product_center">
        <tabbar msg="科普列表"></tabbar>
        <!--<div class="item bannerBox" :style="'background: url(' + BannerByChannelId.channelBanner + ') no-repeat;'">
            <!-- <img :src="BannerByChannelId.channelBanner" alt="" class="banner" /> 
        </div>-->

<!-- 
        <div class="item" style="">
            <van-tabs @click="checkClassList" v-model="active" lazy-render>
                <van-tab v-for="(item,idx) in goodClassList" :key="idx" v-if="item.classStatus == 1 && item.goodsNum && item.goodsNum !=0">
                    <div slot="title">
                        <img class="img" :src="item.classImage" alt=""/> <span class="text text_size11 text_color666">{{item.className}}</span>
                    </div>
                </van-tab>
            </van-tabs>
        </div> -->

        <div class="item_xiaban" :style="goodClassList.length > 1 ? '': 'opacity: 0;height: 24px;'">
            <div class="itemBox">
                <div class="title" slot="title" @click="checkClassList2(idx)" v-for="(item,idx) in goodClassList" :key="idx">
                    <img class="img" :src="item.classImage" alt=""/> 
                    <!-- <textarea class="span text_size11 text_color666" v-model="item.className" rows="2" readonly :cols="gblen(item.className)"></textarea> -->
                    <span class="span text_size11 text_color666" v-text="item.className"></span>
                    <div v-show="active ==idx" :class="{title_act: true, title_act2: title_active == 2, title_act3: title_active == 3}"></div>
                </div>
                <!-- <div class="title" slot="title" @click="checkClassList2(idx + 2)" v-for="(item,idx) in goodClassList" :key="idx + 100" v-if="item.classStatus == 1 && item.goodsNum && item.goodsNum !=0">
                    <img class="img" :src="item.classImage" alt=""/> <span class="span text_size11 text_color666">{{item.className}}</span>
                    <div v-show="active ==idx+2" :class="{title_act: true, title_act2: title_active == 2, title_act3: title_active == 3}"></div>
                </div> -->
            </div>
        </div>

        <div class="item comment2" style="margin-top: -12px;">
             <!-- style="transform: translateY(-24px);" -->
            <div v-for="(item, idx) in goodsList" :key="idx" v-if="goodsList.length > 0" :class="idx % 2 == 0 ? 'list' : 'list'" :style="idx == goodsList.length - 1 ? 'margin-bottom: 65px' : ''">
                <div class="top">
                    <div class="right">
                        <img :src="item.goodImages[0]" alt="" @click="goDetail($event,item.goodsId)"/>
                    </div>

                    <div class="left">
                        <h3 class="text_size14 text_color000" @click="goDetail($event,item.goodsId)">{{item.goodsName}}</h3>
                        <p class="text_size12 text_color666" @click="goDetail($event,item.goodsId)">{{item.goodsDesc}}</p>
                        <!-- <div>
                            <div v-for="(obj, index) in item.goodsLabel.split(',')" :key="index" class="goodsLabel">
                                <img :src="$store.state.api.imgUrl + 'd.png'" alt="" />
                                <span>{{obj}}</span>
                            </div>
                        </div> -->
                        <div class="priceBox">
                            <!--<div  class="price text_size25 text_color0"><i class="btn text_size15">￥</i>{{item.channelPriceStr}}</div>-->
                            <div class="btn2 text_size12 text_colorfff bg_color0" @click="goDetail($event,item.goodsId)">查看详情</div>
                            
                            <!--原 <div class="btn2 text_size12 text_colorfff bg_color0" @click="goDetail($event,item.goodsId)">查看购买</div> -->
                            
                            <!-- <img class="btn text_size9 text_colorfff bg_color0" :src="$store.state.api.imgUrl + 'btn_buy.png'" alt="" @click="goDetail($event,item.goodsId)" /> -->
                        </div>
                    </div>
                </div>
                <!--<div class="bottom">
                    <div :class="{bot1: true, bot4: index != item.goodsLabel.split(',').length -1, text_size11: true, text_color0: true}" v-for="(obj, index) in item.goodsLabel.split(',')" v-text="obj" :key="index"></div>
                </div>-->
            </div>
  
        </div>

         <div class="bot">
            <p class="text_size9 text_color999">版权所有 © 2016-2021广东海善时生物科技有限公司 粤ICP备16114697号-1</p>
        </div>

        <tabBot :channelId="$store.state.channelId"></tabBot>

        <!-- <div class="item bot" :style="goodsList.length < 1 ? '' : '   position: absolute;bottom: 0px;'"> -->
       
    </div>
</template>
<script>
    import './product_center.scss';
    import api from '@/utils/js/api'
    import tabBot from '@/components/tabBot/tabBot.vue';
    import qs from 'qs';

    export default {
        data(){
            return {
                btnText: 'vant-示例',
                active: 0,
                title_active: 2,
                dataList: [],
                // 商品分类列表
                goodClassList: [
                   
                ],
                //分类商品列表
                goodsList: [
                ],
                goodsId:[],
                goodsData:{
                },
                //渠道banner
                BannerByChannelId: '',
                    // channelBanner:  this.$store.state.api.imgUrl + 'banner.png'
                goodsList: [
   
                ],
                
            }
        },
        components:{
            tabBot
        },
        created(){
            // console.log('更新channelId：',this.$store.state.channelId);
            this.$store.commit({
                type: 'comment',
                name: 'title',
                title: '产品中心'
            })

        },
        beforeMount(){
            // window.location.search && qs.parse(window.location.search.substring(1)).code
            if(this.$route.query.code && localStorage.getItem('get_openid')){
                localStorage.removeItem('get_openid');
                this.wechat_code(this.$route.query.code)
            }else{
                // 登录过期判断
                this.verifyUser();
            }
        },
        mounted(){
        },
        methods: {
            gblen(str) {  
                var len = 0;  
                var reg = /[^\x00-\xff]/;
                for (var i=0; i<str.length; i++) { 
                    if(reg.test(str[i])){
                        len += 1.7; 
                    } else{
                        len += 1;
                    }
                }  
                return len / 2;  
            },
            // 登录过期判断
            verifyUser(){
                this.$http({
                    url: api.verifyUser,
                    method: 'post',
                    data: {
                        token: localStorage.getItem('token')
                    }
                }).then(res=>{
                    if(!res.success){
                        console.log('登录信息过期')
                        localStorage.removeItem('userInfo');
                        localStorage.removeItem('token');
                        this.$store.commit({
                            type: 'eachComment',
                            data: [
                                {
                                    name: 'userInfo',
                                    userInfo: ''
                                },
                                {
                                    name: 'token',
                                    token: ''
                                }
                            ]
                        })
                    }

                    //解析url参数channelId等
                    this.get_search();
                })
            },
            //解析url参数channelId等
            get_search(){
                if(!window.location.search){
                    this.queryBannerByChannelId();
                    this.queryGoodClassList();
                    return;
                }

                var search = qs.parse(window.location.search.substring(1));
                if(this.$store.state.is_target == search.target) {
                    this.queryBannerByChannelId();
                    this.queryGoodClassList();
                    return;
                }

                this.$store.commit({
                    type: 'comment',
                    name: 'search',
                    search: search
                })
                if(search.channelId){
                    this.getChannelId(search)
                }else if(search.target){
                    this.getTarget(search);
                }else{
                    //正常查询
                    this.queryBannerByChannelId();
                    this.queryGoodClassList();
                }
                
            },
            // location.search获取渠道Id
            getChannelId(data){
                this.$http({
                    url: api.isChannelValid,
                    method: 'post',
                    data: {
                        channelId: data.channelId,
                        goodsId: data.goodsId || ''
                    }
                }).then(res=>{
                    if(res.success && res.data){
                        if(res.data.type == 2){
                            if(res.data.validValue == 1){
                                this.$store.commit({
                                    type: 'comment',
                                    name: 'channelId',
                                    channelId: data.channelId
                                })
                                this.getTarget(data);
                            }else if(res.data.validValue == 2){
                                this.$store.commit({
                                    type: 'comment',
                                    name: 'channelId',
                                    channelId: data.channelId
                                })
                                this.$toast(res.data.validMsg);
                            }else if(res.data.validValue == 3){
                                this.getTarget(data)
                            }else if(res.data.validValue == 4){
                                this.$toast(res.data.validMsg)
                            }
                        }else{
                            if(res.data.isValid == 1){
                                this.$store.commit({
                                    type: 'comment',
                                    name: 'channelId',
                                    channelId: data.channelId
                                })
                            }
                            this.getTarget(data);
                        }
                        console.log('当前渠道ID有效');
                    }else{
                        console.log('请求失败或当前渠道ID无效');
                    }
                    // 带入渠道Id查询
                    this.queryBannerByChannelId();
                    this.queryGoodClassList();
                }).catch(err=>{
                    this.queryBannerByChannelId();
                    this.queryGoodClassList();
                })
            },
            //location.search获取target
            getTarget(data){
                if(!data.target) return;
                // if(data.target && window.history.length > 1) return;
                if(this.$store.state.loginPath.indexOf(data.target) != -1 && !this.$store.state.userInfo && !this.$store.state.token) return this.wechat();
                this.$store.commit({
                    type: 'comment',
                    name: 'is_target',
                    is_target: data.target
                })
                // if(data.code) delete data.code;
                setTimeout(()=>{
                    this.$router.push({
                        name: data.target,
                        query: data
                    })
                }, 800)
                
            },
            //微信授权取code
            wechat(){
                var str = window.location.search ? '&' : '?';
                var str2 = this.params ? str + qs.stringify(this.params) : '';
                var data ={
                        appid: 'wxe6d64706308fd8b3',
                        // redirect_uri: encodeURI('http://www.pantaoys.com/h5/login'),
                        redirect_uri: encodeURI(window.location.href + str2),
                        response_type: 'code',
                        scope: 'snsapi_userinfo',
                        state: (new Date()).valueOf(),
                }
                localStorage.setItem('get_openid', '1');
                location.href = api.wechat_auth + `?${qs.stringify(data)}#wechat_redirect`;
            },
            // 微信登录公众号
            wechat_code(_code){
                this.$http({
                    url: api.weChatOpenAccountLogin,
                    method: 'post',
                    data: {
                        code: _code,
                        channelId: this.$store.state.channelId
                    }
                }).then(res=>{
                    console.log('weChatOpenAccountLogin',res)
                    if(res.success){
                        localStorage.setItem('token',res.data.token);
                        localStorage.setItem('userInfo',JSON.stringify(res.data));
                        // this.login_text = "绑定手机"
                        this.save_userInfo(true)
                    }else{
                        this.$toast(res.message);
                    }
                    
                })
            },
            // 保存更新userInfo
            save_userInfo(){
                var token = localStorage.getItem('token');
                var userInfo = JSON.parse(localStorage.getItem('userInfo')) || '';
                if(token && userInfo){
                    this.$store.commit({
                        type: 'getUserInfo',
                        must: true
                    })
                }
                this.verifyUser();
            },
            //渠道banner
            queryBannerByChannelId(){
                console.log()
                this.$http({
                    url: api.queryBannerByChannelId,
                    method: 'post',
                    data: {
                        channelId: this.$store.state.channelId,
                    }
                }).then(res=>{
                    console.log('queryBannerByChannelId',res,this.$store.state.channelId);
                    if(res.success && res.data.channelBanner){
                        this.BannerByChannelId = res.data;
                    }else if(!res.success){
                        this.$toast(res.message);
                    }
                })
            },
            //商品分类列表
            queryGoodClassList(){
                this.$http({
                    url: api.queryGoodClassList,
                    method: 'post',
                    data: {
                        channelId: this.$store.state.channelId
                    }
                }).then(res=>{
                    if(res.success && res.data.length > 0){
                        var arr = [];
                        res.data.forEach(item => {
                            if(item.classStatus == 1 && item.goodsNum){
                                arr.push(item);
                            }
                        });
                        this.goodClassList = arr;
                        this.queryGoodsList(arr[this.active]['classId'], arr);
                    }else if(!res.success){
                        this.$toast(res.message);
                    }
                })
            },
            // 分类商品列表
            queryGoodsList(_goodsClassId, _data){
                // console.log(this.goodsId.includes(_goodsClassId), this.goodsId, _goodsClassId)
                if(this.goodsId.includes(_goodsClassId) > 0){
                    this.goodsList = this.goodsData[_goodsClassId];
                    return;
                }
           
                this.$http({
                    url: api.queryGoodsList,
                    method: 'post',
                    data: {
                        channelId: this.$store.state.channelId,
                        goodsClassId: _goodsClassId
                    }
                }).then(res=>{
                    if(res.success){
                        // if(res.data.length > 0){
                        //     res.data[1] = res.data[0];
                        //     res.data[2] = res.data[0];
                        //     res.data[3] = res.data[0];
                        // }
                        var arr = this.goodsId;
                        arr.push(_goodsClassId);
                        this.goodsId = arr;
                        this.goodsList = res.data;
                        this.$set(this.goodsData, _goodsClassId, res.data);
                    }else{
                        this.$toast(res.message);
                    }
                })
            },
            //tab切换
            checkClassList(idx, title){
                this.queryGoodsList(this.goodClassList[idx]['classId'] ,this.goodClassList);

            },
            checkClassList2(idx, title){
                if(this.active == idx){
                    return;
                }
                else if(this.active < idx){
                    this.title_active = 2;
                }
                else{
                    this.title_active = 3;
                }
                this.active = idx;
                this.queryGoodsList(this.goodClassList[idx]['classId'] ,this.goodClassList);
            },
            // 跳转详情页
            goDetail(event,goodsId){
                console.log(event,goodsId);
                this.$store.commit({
                    type: 'comment',
                    name: 'goodsId',
                    goodsId: goodsId
                })
                this.$router.push({
                    name: 'detail',
                    query: {
                        goodsId: goodsId,
                        channelId: this.$store.state.channelId
                    }
                })
            }            
        },
    }
</script>
